import React from 'react';
import { Chip } from '@mui/material';
import {
  Info as InfoIcon,
  Timeline as TimelineIcon,
  Check as CheckIcon
} from '@mui/icons-material';

/**
 * Reusable status chip component for tickets
 */
const StatusChip = ({ status, size = 'small', showIcon = true }) => {
  let color = 'default';
  let icon = null;

  switch (status) {
    case 'Open':
      color = 'info';
      icon = showIcon ? <InfoIcon fontSize="small" /> : null;
      break;
    case 'In Progress':
      color = 'warning';
      icon = showIcon ? <TimelineIcon fontSize="small" /> : null;
      break;
    case 'Closed':
      color = 'success';
      icon = showIcon ? <CheckIcon fontSize="small" /> : null;
      break;
    default:
      color = 'default';
  }

  return (
    <Chip
      icon={icon}
      label={status}
      color={color}
      size={size}
      variant={status === 'Closed' ? 'outlined' : 'filled'}
    />
  );
};

export default StatusChip;
